import { Box, Fab, FabProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FreeShippingBadge = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 54,
  right: 55,
  backgroundColor: theme.palette.success.light,
  color: theme.palette.success.dark,
  fontSize: 10,
  fontWeight: 600,
  paddingLeft: theme.spacing(1.2),
  paddingRight: theme.spacing(1.2),
  paddingTop: '2px',
  paddingBottom: '2px',
  borderRadius: '8px',
  textTransform: 'uppercase',
  zIndex: theme.zIndex.fab + 1,
  border: `1px solid ${theme.palette.success.main}`,
  pointerEvents: 'none',
}));

export const TimerFab = styled(Fab)<FabProps>(({ theme }) => ({
  position: 'fixed',
  bottom: 16,
  right: 16,
  width: 120,
  paddingLeft: 0,
  paddingRight: 0,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
